module.exports = __webpack_public_path__ + "img/github_logo.c21b4530.svg";